import { RenderCellProps } from 'components/DataGrid';
import { ReactNode } from 'react';
import { GridRow } from '../../types';
import { Calendar } from './types';
import { Segments } from './Segments';
import { segmentsContainer } from './SegmentSpan.css';
import invariant from 'tiny-invariant';
import { useRowSegments } from './useRowSegments';

export function View({
  row: { kind, positions },
  calendar,
}: RenderCellProps<GridRow, any> & { calendar: Calendar }): ReactNode {
  invariant(kind !== 'SMART');

  const segments = useRowSegments(positions, calendar);
  return (
    <div className={`${segmentsContainer} readonly`}>
      <Segments segments={segments} selectionState={null} />
    </div>
  );
}
